import * as React from "react";

export interface LayoutContextValue {
  navWidth: number;
  footerHeight: number;
  isMobile: boolean;
}

const LayoutContext = React.createContext<LayoutContextValue | null>(null);

export function useLayoutContext(): LayoutContextValue | null {
  return React.useContext(LayoutContext);
}

export const LayoutProvider = LayoutContext.Provider;
